import { useTheme } from '@emotion/react';
import React, { useCallback } from 'react';

import { Box, Button, Icon, Text, Tooltip } from '~/components/blocks';

type Props = {
  disabled: boolean;
  checkinOrganizationId: string | null;
};

export const DownloadPoster = React.memo((props: Props) => {
  const theme = useTheme();
  const handleClick = useCallback(() => {
    if (!props.checkinOrganizationId) return;

    window.open(
      '/checkin_poster',
      props.checkinOrganizationId,
      'resizable,scrollbars,status,noopener',
    );
  }, [props.checkinOrganizationId]);

  return (
    <Box mt={theme.space.l}>
      {props.disabled ? (
        <Tooltip
          content={
            <>
              ステータスを有効にして保存すると
              <br />
              印刷できるようになります
            </>
          }
        >
          <div>
            <Button icon wide="fill" disabled>
              <Icon size="m" icon="print" />
              店舗掲示用ポスター印刷
            </Button>
          </div>
        </Tooltip>
      ) : (
        <Button icon wide="fill" onClick={handleClick}>
          <Icon size="m" icon="print" />
          店舗掲示用ポスター印刷
        </Button>
      )}
      <Text mt={theme.space.l}>
        店舗チェックインの説明ポスターを印刷して、患者に店舗チェックインQRコードをお知らせください
      </Text>
    </Box>
  );
});

DownloadPoster.displayName = 'DownloadPoster';
